module.exports = __webpack_public_path__ + "images/icons/ic-signature-16-2613af454877c2e273797195f6b0b477.png";